


















































import Vue from 'vue'
import { mapGetters } from 'vuex'

import DateRangePicker from '@/components/DateRangePicker.vue'

import { Status } from '@/enums/status'

/* eslint-disable */ 
import { Order } from '@/models/Order'
import { User } from '@/models/User'
/* eslint-enable */

export default Vue.extend({
  data() {
    return {
      headers: [
        {
          text: 'Customer',
          align: 'start',
          value: 'firstName',
        },
        { text: 'Total Amount', value: 'subtotal' }
      ],
      sortBy: 'subtotal',
      sortDesc: false,
      loading: false,
      customers: [] as User[],
      dateRange: {
        startDate: null as Date,
        endDate: null as Date
      }

    }
  },
  computed: {
    ...mapGetters({
      currentDealerId: 'dealers/currentDealerId'
    }),
    signUps() : number {
      return this.customersInRange.length
    },
    customersInRange() : User[] {
      if (this.dateRange.startDate != null && this.dateRange.endDate != null) {
        return this.customers.filter((user: User) => (this.dateRange.startDate.getTime() <= new Date(user.createdAt).getTime() && this.dateRange.endDate.getTime() >= new Date(user.createdAt).getTime()))
      } else { return this.customers }
    }
  },
  methods: {
    calculateUserSubtotal(user: User) : number {
      const orders : Order[] = user.orders.filter((order: Order) => order.statusId == Status.ORDER)

      let subtotal = 0
      orders.forEach((order: Order) => {
        subtotal = subtotal + order.subtotal
      })

      return subtotal
    },
    isCustomer(user: User) : boolean {
      let bool = false

      user.roles.forEach((role: any) => {
        if (role.id === 2) bool = true
      })

      return bool
    },
    updateDateRange([start, end] : string[]) : void {
      this.dateRange.startDate = new Date(start)
      this.dateRange.endDate = new Date(end)
      this.requestUsers()
    },
    async requestUsers() {
      this.loading = true
      this.customers = []
      const users = await User.getUsersByDealer(this.currentDealerId, '')
      users.forEach((user: User) => {
        if (this.isCustomer(user)) this.customers.push(user)
      })
      this.loading = false
    }
  },
  components: {
    DateRangePicker
  }
})
